var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-id": "mPower-categories-form" } },
    [
      !_vm.loaded
        ? _c("loading")
        : _c("div", {}, [
            _c(
              "div",
              {
                staticClass: "modal-body-fixed-footer",
                staticStyle: { height: "calc(100vh - 63px)" },
              },
              [
                _c(
                  "div",
                  { staticClass: "p-3 mb-1" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("template", { slot: "label" }, [
                          _c("label", [_vm._v("Category Type")]),
                          _c("i", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover",
                                value: {
                                  content:
                                    "The category type that this category should be associated wtih.  Category types are a grouping of categories such as product, them, blog etc....",
                                },
                                expression:
                                  "{\n                content:\n                  'The category type that this category should be associated wtih.  Category types are a grouping of categories such as product, them, blog etc....'\n              }",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass:
                              "fas fa-question-circle text-light ml-2",
                          }),
                        ]),
                        _c("autocomplete-input", {
                          attrs: {
                            path: "/categories/category-types",
                            label: "name",
                            loadOnFocus: "",
                            isObject: "",
                            "track-by": "_id",
                            validate: { required: true },
                          },
                          model: {
                            value: _vm.category.categoryType,
                            callback: function ($$v) {
                              _vm.$set(_vm.category, "categoryType", $$v)
                            },
                            expression: "category.categoryType",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("validated-input", {
                          attrs: {
                            label: "Name",
                            validate: { required: true },
                            "help-options": {
                              content:
                                "Category name which will be displayed on stores.",
                              html: true,
                            },
                          },
                          on: { blur: _vm.categoryNameBlur },
                          model: {
                            value: _vm.category.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.category, "name", $$v)
                            },
                            expression: "category.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [
                        _vm._v("URL Slug\n            "),
                        _c("i", {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover",
                              value: {
                                content:
                                  "Unique slug which creates the URL for this category.  After this is saved it cannot be changed.",
                                html: true,
                              },
                              expression:
                                "{\n                content:\n                  'Unique slug which creates the URL for this category.  After this is saved it cannot be changed.',\n                html: true\n              }",
                              modifiers: { hover: true },
                            },
                          ],
                          staticClass: "fas fa-question-circle text-light ml-2",
                        }),
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.category.slug,
                            expression: "category.slug",
                          },
                        ],
                        ref: "slug",
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.category.slug },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(_vm.category, "slug", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _c(
                      "b-form-group",
                      [
                        _c("template", { slot: "label" }, [
                          _c("label", [_vm._v("Parent Category")]),
                          _c("i", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.hover",
                                value: {
                                  content:
                                    "The parent category that this category should be associated with.  Categories can only have one parent category.",
                                },
                                expression:
                                  "{\n                content:\n                  'The parent category that this category should be associated with.  Categories can only have one parent category.'\n              }",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass:
                              "fas fa-question-circle text-light ml-2",
                          }),
                        ]),
                        _c("autocomplete-input", {
                          attrs: {
                            path: `/categories/all?categoryType=${
                              _vm.category.categoryType?._id
                            }&excludeParent=${_vm.category?._id}&${
                              (_vm.storeId && `storeId=${_vm.storeId}`) || ""
                            }`,
                            label: "name",
                            placeholder: "Choose Parent Category",
                            loadOnFocus: "",
                            isObject: "",
                            "track-by": "_id",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function (props) {
                                return [
                                  _c("span", [
                                    props.option.isGlobal
                                      ? _c("i", {
                                          staticClass: "fas fa-globe mr-2",
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(props.option.name) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "singleLabel",
                              fn: function (props) {
                                return [
                                  _c("span", [
                                    props.option.isGlobal
                                      ? _c("i", {
                                          staticClass: "fas fa-globe mr-2",
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(props.option.name) +
                                        "\n              "
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.category.parentCategory,
                            callback: function ($$v) {
                              _vm.$set(_vm.category, "parentCategory", $$v)
                            },
                            expression: "category.parentCategory",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "mb-3" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "link",
                              "data-id": "Advanced options",
                              block: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.more = !_vm.more
                              },
                            },
                          },
                          [_vm._v("Advanced options")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "collapse", class: { show: _vm.more } },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v("Description"),
                            _c("i", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.hover",
                                  value: {
                                    content:
                                      "Description of the category which can be used for marketing or display purposes.",
                                  },
                                  expression:
                                    "{\n                  content: 'Description of the category which can be used for marketing or display purposes.'\n                }",
                                  modifiers: { hover: true },
                                },
                              ],
                              staticClass:
                                "fas fa-question-circle text-light ml-2",
                            }),
                          ]),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.category.description,
                                expression: "category.description",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "description" },
                            domProps: { value: _vm.category.description },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.category,
                                  "description",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c("validated-input", {
                          staticClass: "mr-2",
                          attrs: {
                            label: "Keywords",
                            name: `keywords`,
                            "help-options": {
                              content:
                                "Use these keywords when search for a category or products assigned to that category",
                              html: true,
                            },
                          },
                          model: {
                            value: _vm.category.keywords,
                            callback: function ($$v) {
                              _vm.$set(_vm.category, "keywords", $$v)
                            },
                            expression: "category.keywords",
                          },
                        }),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "disabled",
                            attrs: { label: "Child Categories" },
                          },
                          [
                            _c("autocomplete-input", {
                              attrs: {
                                path: `/categories/all?categoryType=${
                                  _vm.category.categoryType?._id
                                }&excludeChildren=${
                                  _vm.category.parentCategory?._id ||
                                  _vm.category?._id
                                }&${
                                  (_vm.storeId && `storeId=${_vm.storeId}`) ||
                                  ""
                                }`,
                                label: "name",
                                placeholder: "Choose Parent Category",
                                loadOnFocus: "",
                                isObject: "",
                                multiple: true,
                                "track-by": "_id",
                              },
                              model: {
                                value: _vm.category.childCategories,
                                callback: function ($$v) {
                                  _vm.$set(_vm.category, "childCategories", $$v)
                                },
                                expression: "category.childCategories",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-form-group",
                          [
                            _c("template", { slot: "label" }, [
                              _c("label", [_vm._v("Related Categories")]),
                              _c("i", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.hover",
                                    value: {
                                      content:
                                        "Categories related with to category.  Categories can relate to one or many categories.",
                                    },
                                    expression:
                                      "{\n                  content: 'Categories related with to category.  Categories can relate to one or many categories.'\n                }",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass:
                                  "fas fa-question-circle text-light ml-2",
                              }),
                            ]),
                            _c("autocomplete-input", {
                              attrs: {
                                path: `/categories/all?categoryType=${
                                  _vm.category.categoryType?._id
                                }&exclude=${_vm.category?._id}&${
                                  (_vm.storeId && `storeId=${_vm.storeId}`) ||
                                  ""
                                }`,
                                label: "name",
                                placeholder: "Choose Parent Category",
                                loadOnFocus: "",
                                isObject: "",
                                multiple: true,
                                "track-by": "_id",
                              },
                              model: {
                                value: _vm.category.relatedCategories,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.category,
                                    "relatedCategories",
                                    $$v
                                  )
                                },
                                expression: "category.relatedCategories",
                              },
                            }),
                          ],
                          2
                        ),
                        _vm.canManageStores && !_vm.category.isGlobal
                          ? _c(
                              "b-form-group",
                              [
                                _c("autocomplete-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  attrs: {
                                    path: _vm.storeLink,
                                    label: "storeName",
                                    name: "Assign to Stores",
                                    loadOnFocus: "",
                                    isObject: true,
                                    optionsV: _vm.category.stores,
                                    "track-by": "_id",
                                    multiple: true,
                                    defValue: _vm.category.stores,
                                    "help-options": {
                                      content:
                                        "Stores associated with this category.",
                                      html: true,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function (props) {
                                          return [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(props.option.storeName) +
                                                "\n              "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "singleLabel",
                                        fn: function (props) {
                                          return [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(props.option.storeName) +
                                                "\n              "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3902152438
                                  ),
                                  model: {
                                    value: _vm.category.stores,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.category, "stores", $$v)
                                    },
                                    expression: "category.stores",
                                  },
                                }),
                                _vm.errors.first("stores")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "invalid-feedback d-block",
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(_vm.errors.first("stores")) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.store
                          ? _c(
                              "b-form-group",
                              [
                                _c("autocomplete-input", {
                                  attrs: {
                                    path: `/stores/${_vm.store}/roles`,
                                    label: "name",
                                    name: "Store roles",
                                    loadOnFocus: "",
                                    isObject: true,
                                    optionsV: _vm.category.storeRoles,
                                    "track-by": "_id",
                                    multiple: true,
                                    "help-options": {
                                      content:
                                        "If has at least one role store page with this category will be restricted for customers with same role only",
                                      html: true,
                                    },
                                  },
                                  model: {
                                    value: _vm.category.storeRoles,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.category, "storeRoles", $$v)
                                    },
                                    expression: "category.storeRoles",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-form-group",
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                model: {
                                  value: _vm.category.isHideInMenu,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.category, "isHideInMenu", $$v)
                                  },
                                  expression: "category.isHideInMenu",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Hide In Menu\n              "
                                ),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.hover",
                                      value: {
                                        content:
                                          "Hide this category in Megamenu and Navbar components",
                                        html: true,
                                      },
                                      expression:
                                        "{\n                  content:\n                    'Hide this category in Megamenu and Navbar components',\n                  html: true\n                }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass:
                                    "fas fa-question-circle text-light ml-2",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.canManageStores
                          ? _c(
                              "b-form-group",
                              [
                                _vm.canManageGlobalCategory
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        model: {
                                          value: _vm.category.isGlobal,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.category,
                                              "isGlobal",
                                              $$v
                                            )
                                          },
                                          expression: "category.isGlobal",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              Global Category\n              "
                                        ),
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-popover",
                                              rawName: "v-b-popover.hover",
                                              value: {
                                                content:
                                                  "Allow this category to be used globally across all stores that have Global Categories enabled",
                                                html: true,
                                              },
                                              expression:
                                                "{\n                  content:\n                    'Allow this category to be used globally across all stores that have Global Categories enabled',\n                  html: true\n                }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass:
                                            "fas fa-question-circle text-light ml-2",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.canManageStores
                          ? _c(
                              "b-form-group",
                              [
                                _c(
                                  "b-form-checkbox",
                                  {
                                    model: {
                                      value: _vm.category.isExclude,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.category, "isExclude", $$v)
                                      },
                                      expression: "category.isExclude",
                                    },
                                  },
                                  [
                                    _vm._v("Exclude from stores"),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover",
                                          value: {
                                            content:
                                              "Allow this category to be used globally across all stores that have Global Categories enabled",
                                            html: true,
                                          },
                                          expression:
                                            "{\n                  content:\n                    'Allow this category to be used globally across all stores that have Global Categories enabled',\n                  html: true\n                }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "fas fa-question-circle text-light ml-2",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "mt-3 mb-3" },
                          [
                            _c("label", [_vm._v("Preview Image")]),
                            _c("UploadButton", {
                              attrs: {
                                multiple: false,
                                hasImageType: false,
                                folder: `categories/${_vm.category._id}/designs`,
                                resize: "300",
                              },
                              model: {
                                value: _vm.tempImage,
                                callback: function ($$v) {
                                  _vm.tempImage = $$v
                                },
                                expression: "tempImage",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.canManageGlobalCategory
                          ? _c(
                              "div",
                              { staticClass: "card p-3" },
                              [
                                _c("h5", [_vm._v("Google Merchant Center")]),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v(
                                      "Google Shopping Category ID\n                "
                                    ),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover",
                                          value: {
                                            content:
                                              "Category ID provided by google that most closely relates to this cateogry.",
                                            html: true,
                                          },
                                          expression:
                                            "{\n                    content: 'Category ID provided by google that most closely relates to this cateogry.',\n                    html: true\n                  }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "fas fa-question-circle text-light ml-2",
                                    }),
                                  ]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.category.googleShoppingID,
                                        expression: "category.googleShoppingID",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.category.googleShoppingID,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.category,
                                          "googleShoppingID",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v("Google Shopping Category Name"),
                                    _c("i", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.hover",
                                          value: {
                                            content:
                                              "Path of category provided by google.  Example: Category > Sub Category > etc...",
                                            html: true,
                                          },
                                          expression:
                                            "{\n                    content: 'Path of category provided by google.  Example: Category > Sub Category > etc...',\n                    html: true\n                  }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "fas fa-question-circle text-light ml-2",
                                    }),
                                  ]),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.category.googleShoppingName,
                                        expression:
                                          "category.googleShoppingName",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.category.googleShoppingName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.category,
                                          "googleShoppingName",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]),
                                _vm.canManageStores
                                  ? _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.category.isExcludeFromFeed,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.category,
                                                  "isExcludeFromFeed",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "category.isExcludeFromFeed",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Exclude from product feeds\n                "
                                            ),
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "b-popover",
                                                  rawName: "v-b-popover.hover",
                                                  value: {
                                                    content:
                                                      "Globally remove this supplier from being published in product feeds for all distributors.",
                                                    html: true,
                                                  },
                                                  expression:
                                                    "{\n                    content:\n                      'Globally remove this supplier from being published in product feeds for all distributors.',\n                    html: true\n                  }",
                                                  modifiers: { hover: true },
                                                },
                                              ],
                                              staticClass:
                                                "fas fa-question-circle text-light ml-2",
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "card p-3" },
                          [
                            _c("h5", [_vm._v("Category Part Dimensions")]),
                            _c("DimensionsInputs", {
                              attrs: { dimension: _vm.category?.dimension },
                              on: {
                                onInput: (e) => (_vm.category.dimension = e),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-3 w-100" },
                          [
                            _c("PopulateShippingDimensions", {
                              attrs: {
                                category: _vm.category,
                                title: "Part Dimensions",
                                path: "/average-part-dimension",
                              },
                              on: { select: _vm.selectDimension },
                            }),
                          ],
                          1
                        ),
                        _vm.category.categoryType &&
                        _vm.category.categoryType.slug === "products"
                          ? _c("array-card", {
                              staticClass: "my-3 card card-body",
                              attrs: {
                                heading: "Shipping Packages",
                                "default-item": {
                                  quantity: null,
                                  weight: null,
                                  depth: null,
                                  width: null,
                                  height: null,
                                },
                                headingClass: "h5",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "form-inline" },
                                          [
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Quantity",
                                                name: `quantity`,
                                                validate:
                                                  "required|numeric|max_value:100000",
                                                mask: "######",
                                              },
                                              model: {
                                                value: props.item.quantity,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "quantity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "props.item.quantity",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Weight (lb)",
                                                validate:
                                                  "required|decimal:2|max_value:1000",
                                              },
                                              model: {
                                                value: props.item.weight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "weight",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.item.weight",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Depth (inches)",
                                                validate:
                                                  "required|decimal:2|max_value:1000",
                                              },
                                              model: {
                                                value: props.item.depth,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "depth",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.item.depth",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Width (inches)",
                                                validate:
                                                  "required|decimal:2|max_value:1000",
                                              },
                                              model: {
                                                value: props.item.width,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "width",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.item.width",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Height (inches)",
                                                validate:
                                                  "required|decimal:2|max_value:1000",
                                                mask: "####",
                                              },
                                              model: {
                                                value: props.item.height,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "height",
                                                    $$v
                                                  )
                                                },
                                                expression: "props.item.height",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Cost",
                                                validate: "decimal",
                                              },
                                              on: {
                                                blur: () =>
                                                  _vm.priceChanged(props.item, [
                                                    "flatRateMargin",
                                                    "flatRateCost",
                                                    "flatRatePrice",
                                                  ]),
                                              },
                                              model: {
                                                value: props.item.flatRateCost,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "flatRateCost",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "props.item.flatRateCost",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                label: "Price",
                                                validate: "decimal",
                                              },
                                              on: {
                                                blur: () =>
                                                  _vm.priceChanged(props.item, [
                                                    "flatRateMargin",
                                                    "flatRateCost",
                                                    "flatRatePrice",
                                                  ]),
                                              },
                                              model: {
                                                value: props.item.flatRatePrice,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "flatRatePrice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "props.item.flatRatePrice",
                                              },
                                            }),
                                            _c("validated-input", {
                                              staticClass: "mr-2",
                                              attrs: {
                                                append: "%",
                                                label: "Margin",
                                                validate:
                                                  "numeric|min:0|max:100",
                                              },
                                              on: {
                                                blur: () =>
                                                  _vm.marginChanged(
                                                    props.item,
                                                    [
                                                      "flatRatePrice",
                                                      "flatRateCost",
                                                      "flatRateMargin",
                                                    ]
                                                  ),
                                              },
                                              model: {
                                                value:
                                                  props.item.flatRateMargin,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    "flatRateMargin",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "props.item.flatRateMargin",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "mt-3 w-100" },
                                              [
                                                _c(
                                                  "PopulateShippingDimension",
                                                  {
                                                    attrs: {
                                                      category: _vm.category,
                                                    },
                                                    on: {
                                                      change: (d) =>
                                                        Object.assign(
                                                          props.item,
                                                          d
                                                        ),
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3860282542
                              ),
                              model: {
                                value: _vm.category.shippingPackages,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.category,
                                    "shippingPackages",
                                    $$v
                                  )
                                },
                                expression: "category.shippingPackages",
                              },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "mt-3 w-100" },
                          [
                            _c("PopulateShippingDimensions", {
                              attrs: { category: _vm.category },
                              on: { select: _vm.select },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.errors.any()
                      ? _c(
                          "div",
                          { staticClass: "alert alert-danger m-0" },
                          _vm._l(_vm.errors.all(), function (error) {
                            return _c("div", [_vm._v(_vm._s(error))])
                          }),
                          0
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "modal-fixed-footer card-footer text-right bg-white d-flex align-items-center justify-content-end",
                staticStyle: { "z-index": "1" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.loading || _vm.errors.any(),
                    },
                    on: { click: _vm.submitForm },
                  },
                  [
                    _vm.loading
                      ? _c("i", { staticClass: "far fa-spinner-third fa-spin" })
                      : _vm._e(),
                    _vm._v(" Save Category\n      "),
                  ]
                ),
                _vm.baseCategory._id || _vm.modalMode
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-link mr-2",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("close")
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    )
                  : _c(
                      "router-link",
                      {
                        staticClass: "btn btn-link mr-2",
                        attrs: { to: "/admin/categories" },
                      },
                      [_vm._v("Cancel")]
                    ),
              ],
              1
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }